import {
  container,
  lazyInject,
  lazyInjectNamed,
  lazyInjectTagged,
  lazyMultiInject,
} from './container';

import { withInjectedProps } from './withInjectedProps';

export {
  container,
  lazyInject,
  lazyInjectNamed,
  lazyInjectTagged,
  lazyMultiInject,
  withInjectedProps,
};
